import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyC9Divbg7jBMG0QW74w7MjSn--ejpWnLO0",
  authDomain: "job-tracker-144b8.firebaseapp.com",
  projectId: "job-tracker-144b8",
  storageBucket: "job-tracker-144b8.firebasestorage.app",
  messagingSenderId: "209949307456",
  appId: "1:209949307456:web:e67bec0939d4ac4bac65a5"
};

const app = initializeApp(firebaseConfig);
export { app };
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Modalità demo rimossa - ora solo Firebase reale 